import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { IDeleteOrganizationJobResult, IMeetingsJobDetails } from '../../../api/jobs.dao';

const deleteOrganizationJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IMeetingsJobDetails, IDeleteOrganizationJobResult>> = {
    reviewCompletedJobButtonText: 'Ok',
    reviewFailedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IMeetingsJobDetails, IDeleteOrganizationJobResult>) => {
        return (
            <div className='delete-attendee-result-alert'>
                <div>{`Organization ${props.result?.name || ''} has been deleted`}</div>
            </div>
        );
    },
    failedComponent: (props: IJobResultComponentProps<IMeetingsJobDetails, IDeleteOrganizationJobResult>) => {
        return <FormattedMessage
            defaultMessage='Organization deletion {name} has failed'
            description='Label text'
            id='oe.organization.deletionFailed'
            values={{
                name: props.result?.name || ''
            }}
        />;
    }
};

export { deleteOrganizationJobProperties };
